module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeftLight-0aadf9cf5872d5e54e5f38b5d181ea31.png";